import { styled } from "styled-components";

export const ProfilePageTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  width: 600px;
`;
